export default __webpack_public_path__ + "static/media/11-interview-principles.1e5e12ff.svg";